import { isEqual } from 'vet-bones/utils';

import { MappingIdentifier } from 'src/containers/ProjectDiagram/types/data';

export const areIdentifiersEqual = (
  firstIdentifier: MappingIdentifier,
  secondIdentifier: MappingIdentifier
) => {
  const firstTypeAndValues = firstIdentifier.parts.map(({ type, value }) => ({
    type,
    value,
  }));
  const secondTypeAndValues = secondIdentifier.parts.map(({ type, value }) => ({
    type,
    value,
  }));

  return (
    firstIdentifier.baseIri === secondIdentifier.baseIri &&
    isEqual(firstTypeAndValues, secondTypeAndValues)
  );
};
